import { makeStyles } from '@material-ui/core/styles'

import { colors, fontSize } from '~/styles/theme'

const style = makeStyles((theme) => ({
  mapBox: {
    backgroundColor: colors.White,
    boxShadow: '1px 2px 4px rgba(193, 193, 193, 0.18)',
    '& .leaflet-top': {
      bottom: 0,
    },
    '& .leaflet-left': {
      left: 'unset',
      right: 0,
    },
    '& .leaflet-top .leaflet-control-zoom': {
      top: '80%',
      bottom: 0,
      transform: 'translateY(-20%)',
    },
  },
  mapWrapper: {
    height: 'calc(100vh - 56px)',
    width: '100%',
  },
  mapContainer: {
    height: '100%',
    width: '100%',
    '& .leaflet-tooltip': {
      backgroundColor: 'transparent',
      fontSize: fontSize[16],
      fontWeight: theme.typography.fontWeightBold,
      border: 'none',
      boxShadow: 'none',
    },
    '& .leaflet-tooltip-top:before': {
      borderTopColor: 'transparent',
    },
    '& .leaflet-popup-content-wrapper': {
      minWidth: '12.4vw',
      minHeight: 'fit-content',
    },
  },
  iconButtonShareMap: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: colors.White,
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  filterIcon: {
    '& > div': {
      display: 'flex',
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.White,
    padding: theme.spacing(1.5, 3),
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    zIndex: 1100,
    minHeight: 56,
  },
  navbarTitle: {
    fontWeight: 700,
    fontSize: fontSize[18],
    letterSpacing: 1.5,
    color: theme.palette.text.primary,
  },
  expiryChip: {
    backgroundColor: '#ed6c02',
    color: colors.White,
    fontWeight: 700,
    fontSize: fontSize[14],
    height: 36,
    borderRadius: 18,
    '& .MuiChip-label': {
      padding: theme.spacing(0, 2),
    },
  },
  expiryChipExpired: {
    backgroundColor: theme.palette.error.main,
  },
  expiredScreen: {
    height: 'calc(100vh - 56px)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.White,
    gap: theme.spacing(2),
  },
  expiredIcon: {
    fontSize: 64,
    lineHeight: 1,
    marginBottom: theme.spacing(1),
  },
  expiredTitle: {
    fontSize: fontSize[28],
    fontWeight: 700,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  expiredSubtitle: {
    fontSize: fontSize[16],
    color: theme.palette.text.secondary,
    textAlign: 'center',
    lineHeight: 1.8,
  },
}))

export default style
